import { SvgIcon, SvgIconProps, styled } from '@material-ui/core'

const TextBackgroundColor = (props: SvgIconProps) => (
  <SvgIcon width="17" height="17" viewBox="0 0 17 17" {...props}>
    <rect width="17" height="17" rx="3" fill={props.fill} />
  </SvgIcon>
)

export default styled(TextBackgroundColor)({ fontSize: '1.2rem' })
